import React from 'react';
import { noop } from 'lodash';

import { useContextHandling } from 'common/hooks/useContextHandling';

import { SectionWidgetConfig } from './global-widget-config-types';

type SectionWidgetConfigContextValue = {
  getParentSectionConfig: (widgetId: string) => SectionWidgetConfig | undefined;
  getSectionConfig: (sectionId: string) => SectionWidgetConfig | undefined;
  updateParentSectionConfig: (widgetId: string, config: SectionWidgetConfig) => void;
};

export const SectionWidgetConfigContext =
  React.createContext<SectionWidgetConfigContextValue | null>(null);

const fallbackState: SectionWidgetConfigContextValue = {
  getParentSectionConfig: () => undefined,
  getSectionConfig: () => undefined,
  updateParentSectionConfig: noop,
};

export const useSectionWidgetConfig = () => {
  return useContextHandling(SectionWidgetConfigContext, fallbackState);
};
